
import { defineComponent, PropType, ref } from "vue";
import { ArticleModel } from "@/entities/Article";
import { imageUrlBuilder } from "@/services/sanity";
import { formatDateLong } from "@/utils/dateTimeFormatter";

export default defineComponent({
  props: {
    article: {
      type: Object as PropType<ArticleModel>,
      required: true,
    },
    isTwoColumns: {
      type: Boolean,
    },
  },
  setup() {
    const VUE_APP_INSTANCE = "es";
    const imageLoaded = ref(false);

    return {
      imageUrlBuilder,
      formatDateLong,
      VUE_APP_INSTANCE,
      imageLoaded,
    };
  },
});
